'use client';
import React from 'react';
import './PlayerAccount.css';
import { useTranslations } from 'next-intl';
import { useGetUserInfo } from '../../../../providers/queries/user-info';
import Link from 'next/link';
import AccountProfile from '../../AccountProfile/account-profile';
import RoasterTalent from './RoasterTalent';
import { IcoMoonIcon } from '../../../../../../../packages/ui/components/icons';
import { tryFormatThousands } from '@wwe-portal/utils/format';
// import { DateTime } from 'luxon';
// import { reFormatRelativeTime } from '../../../../utils/dates';
import { formatJsDateToRelativeDate } from '@wwe-portal/utils/date/datefns';
import { slugify } from '@wwe-portal/web/utils/string';

function PlayerAccount({
  userId,
  playerName,
  factionName,
  lastActivityDate,
  rosterTalent,
  avatarUrl,
  avatarFrameUrl,
  avatarRarity,
}: Readonly<{
  userId: string;
  playerName: string;
  factionName: string;
  lastActivityDate: string;
  rosterTalent: number;
  avatarUrl?: string;
  avatarFrameUrl?: string;
  avatarRarity: string;
}>): React.JSX.Element {
  const t = useTranslations();
  const { data: currentUser } = useGetUserInfo();
  const lastActivity = formatJsDateToRelativeDate(lastActivityDate ?? '');
  // const lastUpdate = DateTime.fromISO(lastActivityDate).startOf('day');

  return (
    <div className="player-account w-full md:w-auto">
      <div className="flex w-full flex-col items-center justify-center text-center md:flex-row md:items-start md:justify-start">
        <AccountProfile
          userId={userId}
          avatarUrl={avatarUrl}
          avatarFrameUrl={avatarFrameUrl}
          avatarRarity={avatarRarity}
        />
        <div className="ml-0 flex flex-col items-center md:ml-[15px] md:items-start">
          <p className="mb-[10px] mt-5 text-left text-base">
            {currentUser &&
            currentUser.userId === userId &&
            currentUser.temporaryNickname
              ? currentUser.temporaryNickname
              : playerName}
          </p>
          {factionName ? (
            <Link
              href={`/faction/${slugify(factionName || '')}`}
              className="text-text600 m-0 text-left text-sm font-medium no-underline"
              data-id={`player_profile_faction_${userId}_name_${factionName}`}
            >
              {factionName}
            </Link>
          ) : (
            <span className="text-text600 m-0 text-left text-sm font-medium no-underline">
              {t('no_faction')}
            </span>
          )}
          <div className="player-account__activity flex">
            <div className="player-account__box mr-[10px] flex min-w-[200px] items-center p-[10px]">
              <IcoMoonIcon
                iconName="money-dollar-circle"
                className="text-inlineTextColor11 size-[14px]"
              />
              <div className="player-account__box__text text-text600 ml-[10px] flex items-center justify-center text-xs">
                {t('last_active')}:
                <p className="player-account__box__text text-text500 mb-0 ml-[5px] flex items-center text-xs">
                  {/* {reFormatRelativeTime(lastUpdate)} */}
                  {lastActivity}
                </p>
              </div>
            </div>
            <RoasterTalent
              classes="player-account__box__text"
              rosterTalent={tryFormatThousands(rosterTalent)}
            />
          </div>
        </div>
      </div>
    </div>
  );
}

export default PlayerAccount;
